module.exports = __webpack_public_path__ + "fonts/nationale-bold.0f55c37.woff";